var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M19.224 25.008h-8.459c-3.188 0-5.775-2.582-5.775-5.776v-8.464c0-3.191 2.587-5.778 5.775-5.778h8.459C22.415 4.99 25 7.577 25 10.768v8.464c0 3.194-2.585 5.776-5.776 5.776zm3.933-14.289c0-2.118-1.717-3.836-3.835-3.836h-8.657c-2.114 0-3.833 1.718-3.833 3.836v8.662c0 2.118 1.719 3.838 3.833 3.838h8.657c2.118 0 3.835-1.72 3.835-3.838v-8.662zm-2.797.148c-.668 0-1.209-.54-1.209-1.21 0-.668.541-1.209 1.209-1.209.669 0 1.209.541 1.209 1.209 0 .67-.54 1.21-1.209 1.21zm-5.366 9.378c-2.868 0-5.19-2.327-5.19-5.194 0-2.869 2.322-5.196 5.19-5.196 2.867 0 5.194 2.327 5.194 5.196 0 2.867-2.327 5.194-5.194 5.194zm0-8.563c-1.858 0-3.364 1.509-3.364 3.369 0 1.859 1.506 3.366 3.364 3.366 1.86 0 3.365-1.507 3.365-3.366 0-1.86-1.505-3.369-3.365-3.369z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.991980ddcb8c67b83f6f430035fa414a.svg";
export { ForwardRef as ReactComponent };